// Central home for the roles the app has business logic for: Cognito role groups,
// plus the portal-only ROLE_AUTHENTICATED. Named constants only — no runtime logic.
// Import these instead of hard-coding role strings at call sites.
//
// Migration note: bare group strings ("admin", "roadmin", "internal")
// should move here over time.

// Portal-only role (no Cognito group): every signed-in user holds it implicitly. Named
// like a Cognito role group (ROLE_ prefix) because it shares ROLE_PERMISSIONS keys with them.
export const ROLE_AUTHENTICATED = "ROLE_authenticated";

export const ROLE_JOURNEY_MANAGER_BETA_USER_ADVANCED_EDIT = "ROLE_journey_manager_beta_user_advanced_edit";
export const ROLE_POLLY_RESEARCH_MANAGER = "ROLE_polly_research_manager";
export const ROLE_POLLY_CRAWL_SOURCE_MANAGER = "ROLE_polly_crawl_source_manager";

// Temporary: hides the Klaviyo entry points while the integration is piloted with
// selected clients. Remove this constant and its call sites at general availability.
export const ROLE_KLAVIYO_BETA_USER = "ROLE_klaviyo_beta_user";
